import React, { Suspense, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { EagleAIApp, EagleAIConfig } from '@eagle-projects/eagle-ai';
import { getCurrentUser, getEagleAIUrl } from '../shared/common';

const config: Partial<EagleAIConfig> = {
	logo: '/alphaprep.png',
	logoAlt: 'AlphaPrep Logo',
	brandName: 'AlphaPrep',
	apiBaseUrl: getEagleAIUrl() || '',
	showThemeToggle: false,
};

const EagleAIStandalonePage: React.FC = () => {
	const [userId, setUserId] = useState<string | null>(null);

	useEffect(() => {
		const user = getCurrentUser();
		if (user) setUserId(user);
	}, []);
	return (
		<Box sx={{ height: 'calc(100vh - 64px)', width: '100%' }}>
			<Suspense fallback={<div>Loading...</div>}>
				<EagleAIApp config={{ ...config, userId: userId || undefined }} />
			</Suspense>
		</Box>
	);
};

export default EagleAIStandalonePage;
